import { Button } from '@one-thd/sui-atomic-components';
import React, { useState, MouseEvent } from 'react';
import {
  GetTrackShipmentData,
  GetTrackYourTruckData,
} from '../../../hooks/track-shipment-hooks';
import { getWindow } from '../../../utils/general';
import {
  ITrackShipment,
  ITrackYourTruckRequest,
} from '../../../models/order-details/track-shipment';
import { getFulfillmentStatus } from '../util/FulfillmentStatus';
import { TrackShipmentError } from './TrackShipmentError';
import TrackShipmentModal from './TrackShipmentModal';
import { isGiftCardInFulfillmentGroup } from '../util/general';

export const TrackShipment = ({
  buttonVariant = 'primary',
  orderId,
  fulfillmentGroup,
  fulfillmentType,
  shipmentIndex,
}: ITrackShipment) => {
  const { isFulfillmentSTHorBOSS, isMA, isFulfillmentBODFSorDFS } =
    getFulfillmentStatus(fulfillmentType);

  const [modalOpen, setModalOpen] = useState(false);
  const handleModalClose = () => setModalOpen(false);
  const [defaultErrorFlag, setDefaultErrorFlag] = useState(false);

  // Regular Tracking API
  //  If any of these values are undefined then TrackShipment Button will be disabled.
  const providerCode =
    fulfillmentGroup?.shippingAndHandling?.shipments?.shipment?.[shipmentIndex]
      ?.shippingProviderCode;

  const uniqueTrackingNumbers =
    fulfillmentGroup?.shippingAndHandling?.shipments?.shipment?.filter(
      (obj, index) => {
        return (
          index ===
          fulfillmentGroup?.shippingAndHandling?.shipments?.shipment?.findIndex(
            (obj2) => obj?.trackingNumber === obj2?.trackingNumber,
          )
        );
      },
    );

  let trackingNumber = uniqueTrackingNumbers?.[shipmentIndex]?.trackingNumber;

  if (trackingNumber?.[0] === '0') {
    trackingNumber = Number(trackingNumber ?? 0).toString();
  }

  const trackShipmentPayload = {
    orderNumber: orderId,
    providerCode,
    trackingNumber,
    applicationName: '',
  };

  const {
    trackShipmentData,
    trackShipmentError,
    trackShipmentLoaded,
    handleTrackShipmentAPIButtonClick,
  } = GetTrackShipmentData(trackShipmentPayload);

  const trackShipmentForSTHAndBOSSFunction = () => {
    handleTrackShipmentAPIButtonClick();
    setModalOpen(true);
  };
  // FOR Major Appliance
  const trackShipmentForMajorAppliance = () => {
    const applianceDeliveries =
      fulfillmentGroup?.shippingAndHandling?.applianceDeliveries;
    if (isMA && applianceDeliveries) {
      const deliveryTrackerUrl = applianceDeliveries?.[0]?.deliveryTrackerUrl;
      getWindow()?.open(deliveryTrackerUrl, '_blank');
    }
  };

  // FOR BODFS/DFS

  const bodfsDeliveries =
    fulfillmentGroup?.bodfsDeliveryAndHandling?.bodfsDeliveries;
  const name = `${
    bodfsDeliveries?.[0]?.deliveryAddress?.name?.firstName || ''
  } ${bodfsDeliveries?.[0]?.deliveryAddress?.name?.lastName || ''}`.trim();

  const trackYourTruckPayload: ITrackYourTruckRequest = {
    trackYourTruckRequest: {
      name,
      workOrderNumber: bodfsDeliveries?.[0]?.workOrderNo || '',
      orderNumber: orderId,
      capReservationId: bodfsDeliveries?.[0]?.capacityReservationId || '',
    },
  };

  const {
    trackYourTruckData,
    trackYourTruckError,
    trackYourTruckLoaded,
    handleTrackYourTruckAPICall,
  } = GetTrackYourTruckData(trackYourTruckPayload);

  const trackShipmentForBODFSAndDFSFunction = () => {
    if (bodfsDeliveries) {
      // Track Your Truck

      handleTrackYourTruckAPICall();
      if (trackYourTruckData && trackYourTruckLoaded) {
        const { trackerUrl } = trackYourTruckData;
        getWindow()?.open(trackerUrl, '_blank');
      } else if (trackYourTruckError && trackYourTruckLoaded) {
        setDefaultErrorFlag(true);
      }
    }
    setDefaultErrorFlag(true);
  };

  const handleOnClickForTrackShipment = (event: MouseEvent) => {
    event.preventDefault();
    if (isFulfillmentSTHorBOSS) {
      trackShipmentForSTHAndBOSSFunction();
      return;
    }
    if (isMA) {
      trackShipmentForMajorAppliance();
      return;
    }
    if (isFulfillmentBODFSorDFS) {
      trackShipmentForBODFSAndDFSFunction();
      return;
    }
    setDefaultErrorFlag(true);
  };

  /*

      trackShipmentData is from the API and shipmentTrackingDetail is the inner object. 
      when we define shippingProviderLogo with shipmentTrackingDetail it will be
      TypeError of null as trackShipmentData is only fetched when the button is clicked.
      hence we define {} for the null check
  */

  return (
    <>
      {(trackShipmentError || defaultErrorFlag) && (
        <TrackShipmentError />
        /* NOTE:  TrackShipment Error is separated as a separated component even it seems to be static component but 
       we might have to add other unhappy paths for other fulfillment types.
       */
      )}
      {!isGiftCardInFulfillmentGroup(fulfillmentGroup) && (
        <div className="card-fix">
          <Button
            variant={buttonVariant}
            onClick={(event: MouseEvent) =>
              handleOnClickForTrackShipment(event)
            }
          >
            Track Shipment
          </Button>
        </div>
      )}

      {/* FOR STH AND BOSS ONLY */}
      {trackShipmentLoaded && trackShipmentData && (
        <TrackShipmentModal
          modalOpen={modalOpen}
          handleModalClose={handleModalClose}
          shipmentTrackingDetail={trackShipmentData}
        />
      )}
    </>
  );
};

export default TrackShipment;
